import React, { useState } from 'react';
import { X } from 'lucide-react';

/**
 * Chip-style multi-value input. Type a value and press Enter (or comma) to add it.
 * Values render as removable tags. Paste with commas splits automatically.
 */
export const TagInput = ({ values = [], onChange, placeholder = 'Type and press Enter…', dataTestid }) => {
  const [text, setText] = useState('');

  const commit = (raw) => {
    const parts = raw.split(',').map(x => x.trim()).filter(Boolean);
    const fresh = parts.filter(p => !values.includes(p));
    if (fresh.length) onChange([...values, ...fresh]);
    setText('');
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      if (text.trim()) commit(text);
    } else if (e.key === 'Backspace' && !text && values.length) {
      onChange(values.slice(0, -1));
    }
  };

  return (
    <div
      data-testid={dataTestid}
      className="flex flex-wrap items-center gap-1.5 min-h-[40px] w-full rounded-md border border-stone-200 bg-white px-2 py-1.5 focus-within:ring-2 focus-within:ring-stone-400 focus-within:ring-offset-0"
    >
      {values.map(v => (
        <span key={v} className="inline-flex items-center gap-1 pl-2 pr-1 py-0.5 rounded-full bg-stone-100 text-[12px] text-stone-800">
          {v}
          <button
            type="button"
            data-testid={`${dataTestid || 'tag'}-remove-${v}`}
            onClick={() => onChange(values.filter(x => x !== v))}
            className="rounded-full p-0.5 hover:bg-stone-200 text-stone-500"
            title={`Remove ${v}`}
          >
            <X className="w-3 h-3" />
          </button>
        </span>
      ))}
      <input
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={onKeyDown}
        onBlur={() => text.trim() && commit(text)}
        placeholder={values.length ? '' : placeholder}
        className="flex-1 min-w-[140px] bg-transparent outline-none text-[13px] py-0.5 placeholder:text-stone-400"
      />
    </div>
  );
};
